/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Free_Moth_FlowInputs */

const en_light_free_moth_flow = /** @type {(inputs: Light_Free_Moth_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_light_free_moth_flow = /** @type {(inputs: Light_Free_Moth_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Light_Free_Moth_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_free_moth_flow = /** @type {((inputs?: Light_Free_Moth_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Free_Moth_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_free_moth_flow(inputs)
	return de_light_free_moth_flow(inputs)
});